<template>
  <li class="glide__slide">
    <slot />
  </li>
</template>

<script setup lang="ts"></script>

<style scoped lang="scss"></style>
